import { render, staticRenderFns } from "./TermsOptions.vue?vue&type=template&id=406439ea"
import script from "./TermsOptions.vue?vue&type=script&lang=js"
export * from "./TermsOptions.vue?vue&type=script&lang=js"
import style0 from "./TermsOptions.vue?vue&type=style&index=0&id=406439ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports